/**
 * This interface is for an authentication plugin.
 * @type {string}
 */
const name = 'authentication'
export default name
